// /*
//   Author: Piyush Dubey
// */
// import React from "react";
// import Layout from "./layout";
// import i18n from "../../i18nNext";

// // Functional Component
// // It'll save unnecessary re-rendring.

// const CantSignIn = props => {
//     return (
//         <div>
//             <Layout subHeader="cantSignIn" />
//             <div className="loginContainer" style={{ width: "325px", color: "#54698d" }}>
//                 <p>{`${i18n.t("err.youCanSign")}`}</p>
//                 <p>
//                     {`${i18n.t("err.ifYouStill")} `}{" "}
//                     <a
//                         href="mailto:help@happay.in"
//                         style={{ fontWeight: "500", color: "#62d2a2", cursor: "pointer" }}
//                     >
//                         help@happay.in
//                     </a>
//                 </p>
//             </div>
//         </div>
//     );
// };
// export default CantSignIn;

// //
// //  If it's require to make react component then comment upper part
// //  and uncomment bellow part.
// //

// // export default class CantSignIn extends React.Component {
// //     constructor() {
// //         super();
// //     }

// //     _renderInputField() {
// //         return (
// //             <div className= "loginContainer" style={{width: '325px', color: '#54698d'}}>
// //                 <p>
// //                 {`You can sign in using OTP sent to your
// //                   registered email and mobile number to
// //                   access your account if you have forgotten
// //                   your password.`}
// //                 </p>
// //                 <p>
// //                 {`If you still face issues with Sign in, you
// //                   can contact us at `} <span style={{fontWeight: '500', color: '#62d2a2', cursor: 'pointer'}}>help@happay.in</span>
// //                 </p>
// //             </div>
// //         );
// //     }

// //     render() {
// //         return (
// //             <div>
// //                 <Layout
// //                     subHeader="cantSignIn"
// //                 />
// //                 {this._renderInputField()}
// //             </div>
// //         );
// //     }
// // }

//---------------- Start External Library Import --------------------//
import React from "react";
import CantSignIn from "@techsoftware/happay-widgets/CantSignin";
import history from "helper/history";
//---------------- End External Library Import --------------------//

//------------------- Start Helpers Dependency Import -------------------------------------//
import i18n from "../../i18nNext";
import Common from "../../constants/common";
//------------------- End Helpers Dependency Import -------------------------------------//

import HDFCLogo from "../../../public/assets/images/bank/HDFC_Bank_Logo.svg";

const CantSignInPage = props => {
    const { ProductLogo, breakPoints, privacyPolicyUrl, termOfUseUrl } = props;
    return (
        <CantSignIn
            containerClassName={`signin-container ${
                Common._checkIfHdfcUrl() ? "hdfcPortal" : "happayPortal"
            }`}
            logo={Common._checkIfHdfcUrl() ? HDFCLogo : ProductLogo}
            breakPoints={breakPoints}
            onClickBack={() => {
                history.goBack();
            }}
            privacyPolicyUrl={!Common._checkIfHdfcUrl() && privacyPolicyUrl}
            termOfUseUrl={!Common._checkIfHdfcUrl() && termOfUseUrl}
            privacyPolicyText={!Common._checkIfHdfcUrl() && i18n.t("common.privacyPolicy")}
            termOfUseText={!Common._checkIfHdfcUrl() && i18n.t("common.termsOfUse")}
            cantSignInHeader={i18n.t("logIn.cantSignIn?")}
            cantSignInSubHeaderOne={i18n.t("err.youCanSign")}
            cantSignInSubHeaderTwo={i18n.t("err.ifYouStill")}
            backButtonText={i18n.t("btn.back")}
            helpEmailID={Common._checkIfHdfcUrl() && "help.hdfcbank@happay.com"}
        />
    );
};
export default CantSignInPage;
